module.exports = __webpack_public_path__ + "media/images/common/check_delete_btn_l-056ec58e43805bea90b12a1780901f37.png";